// extracted by mini-css-extract-plugin
module.exports = {"numericalSelect":"NumericalSelect_numericalSelect__EbjBA","labels":"NumericalSelect_labels__2eVIe"};